import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SiteState } from 'src/app/shared/models';

import * as CopyAdviceActions from '../../../copy-advice/store/copy-advice.actions';
import * as CopyAdviceSelectors from '../../../copy-advice/store/copy-advice.selectors';

@Component({
  selector: 'app-copy-advice-status',
  templateUrl: './copy-advice-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyAdviceStatusComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  showCopyStatus$ = this.store.pipe(select(CopyAdviceSelectors.showCopyStatus));
  dismissCopyAdviceStatus() {
    this.store.dispatch(CopyAdviceActions.dismissCopyAdviceStatus());
  }
}
